import styled from 'styled-components'

import { LinkAddUnstyled } from 'Components/LinkAdd/unstyled'

export const LinkAdd = styled(LinkAddUnstyled)`
  display: block;
  float: ${props => props.float || 'left'};
  width: 40px;
  height: 40px;
  position: relative;
  background: ${props => props.theme.colors.primary};
  border-radius: 4px;
  cursor: pointer;

  svg {
    position: absolute;
    height: 100%;
    width: 14px;
    fill: ${props => props.theme.colors.white};
    left: 0;
    right: 0;
    margin: auto;
  }
`



// WEBPACK FOOTER //
// ./src/Components/LinkAdd/index.js